import type { Category, CategoryType } from '../types/category';

const CATEGORY_SETTINGS_STORAGE_KEY = 'category_settings';
const DEFAULT_TYPE: CategoryType = 'Discretionary';

/**
 * Get category type from stored settings (localStorage)
 * Falls back to default 'Discretionary' if not set
 * Returns null if explicitly set to null (Ignore)
 */
export function getCategoryType(category: Category): CategoryType {
  // Load settings from localStorage
  const stored = localStorage.getItem(CATEGORY_SETTINGS_STORAGE_KEY);
  const settings: Record<number, CategoryType> = stored ? JSON.parse(stored) : {};
  
  // If category ID exists in settings, return that value (even if null)
  // Otherwise return default
  if (category.id in settings) {
    return settings[category.id];
  }
  
  return DEFAULT_TYPE;
}
